import classNames from "classnames"
import Image from "next/image"
import React from "react"

import { useTranslation } from "@bounce/i18n"
import { LinkList } from "@bounce/web-components"

import { useCities } from "./useCities"
import type { CityLink } from "@/libs/bounce/cities"

import illustration from "@/assets/img/hands-free-travel.png"

type Link = {
  href: string
  locale?: string
  name: string
}

type CityListProps = {
  cities: CityLink[]
  className?: string
  mapLinks: (city: CityLink) => Link
}

export const CityList = ({ cities, mapLinks, className }: CityListProps) => {
  const [t] = useTranslation()
  const regions = useCities({
    cities,
  })

  return (
    <section className={classNames("mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
      <div className="relative w-full">
        <h2 className="title2 mb-16 pr-24 text-black md:max-w-[600px]">
          {t("page.cities.listTitle", "Explore the world")}
        </h2>
        <Image
          src={illustration}
          width={163}
          height={163}
          loading="lazy"
          alt={t("screen.homeScreen.cities.altV1", "Hands free travel, Around the globe")}
          className="absolute right-0 top-0 mr-6 hidden size-[95px] md:top-[-34px] md:flex md:size-[123px]"
        />
      </div>
      {regions.map(({ id, label, links }, index) => (
        <LinkList
          key={id}
          label={label}
          links={links.map(mapLinks)}
          className={classNames("w-full", !!index && "mt-12")}
        />
      ))}
    </section>
  )
}
